import * as Icons from '@shared/assets/icons/v2';
import { MBImageURISource } from './props';

export const MBIconV2NameMap = {
  'add-reactions': Icons.AddReactionsIcon,
  'address-book': Icons.AddressBookIcon,
  airplane: Icons.AirplaneIcon,
  'app-circles': Icons.AppCirclesIcon,
  apple: Icons.AppleIcon,
  'archive-box': Icons.ArchiveBoxIcon,
  'arm-strong': Icons.ArmStrongIcon,
  'arrow-branch': Icons.ArrowBranchIcon,
  'arrow-circle-down': Icons.ArrowCircleDownIcon,
  'arrow-circle-up': Icons.ArrowCircleUpIcon,
  'arrow-exit': Icons.ArrowExitIcon,
  'arrow-full-down': Icons.ArrowFullDownIcon,
  'arrow-full-left': Icons.ArrowFullLeftIcon,
  'arrow-full-right': Icons.ArrowFullRightIcon,
  'arrow-full-up-filled': Icons.ArrowFullUpFilledIcon,
  'arrow-full-up': Icons.ArrowFullUpIcon,
  'arrow-link-out': Icons.ArrowLinkOutIcon,
  'arrow-link-out-small-2': Icons.ArrowLinkOutIcon, // legacy alias for arrow-link-out
  'arrow-move-down': Icons.ArrowMoveDownIcon,
  'arrow-move-left': Icons.ArrowMoveLeftIcon,
  'arrow-move-right': Icons.ArrowMoveRightIcon,
  'arrow-move-up': Icons.ArrowMoveUpIcon,
  'arrow-outline-left': Icons.ArrowOutlineLeftIcon,
  'arrow-outline-right': Icons.ArrowOutlineRightIcon,
  'arrow-point-down-heavy': Icons.ArrowPointDownHeavyIcon,
  'arrow-point-down': Icons.ArrowPointDownIcon,
  'arrow-point-left-heavy': Icons.ArrowPointLeftHeavyIcon,
  'arrow-point-left': Icons.ArrowPointLeftIcon,
  'arrow-point-right-heavy': Icons.ArrowPointRightHeavyIcon,
  'arrow-point-right': Icons.ArrowPointRightIcon,
  'arrow-point-up-heavy': Icons.ArrowPointUpHeavyIcon,
  'arrow-point-up': Icons.ArrowPointUpIcon,
  'arrow-refresh': Icons.ArrowRefreshIcon,
  'arrow-repeat': Icons.ArrowRepeatIcon,
  'arrow-shuffle': Icons.ArrowShuffleIcon,
  'arrows-collapse': Icons.ArrowsCollapseIcon,
  'arrows-expand': Icons.ArrowsExpandIcon,
  'arrow-revert': Icons.ArrowRevertIcon,
  'arrows-swap': Icons.ArrowsSwapIcon,
  'arrows-up-down-heavy': Icons.ArrowsUpDownHeavyIcon,
  'arrows-up-down-in': Icons.ArrowsUpDownInIcon,
  'arrows-up-down-out': Icons.ArrowsUpDownOutIcon,
  'arrows-up-down': Icons.ArrowsUpDownIcon,
  'arrows-up-down-swap': Icons.ArrowsUpDownSwapIcon,
  ascending: Icons.AscendingIcon,
  'at-symbol': Icons.AtSymbolIcon,
  'avatar-add-group': Icons.AvatarAddGroupIcon,
  'avatar-empty': Icons.AvatarEmptyIcon,
  'avatar-group': Icons.AvatarGroupIcon,
  'avatar-invite': Icons.AvatarInviteIcon,
  'avatar-location': Icons.AvatarLocationIcon,
  'avatar-multi': Icons.AvatarMultiIcon,
  'avatar-pin': Icons.AvatarPinIcon,
  'avatar-search': Icons.AvatarSearchIcon,
  avatar: Icons.AvatarIcon,
  award: Icons.AwardIcon,
  'bag-shopping': Icons.BagShoppingIcon,
  basketball: Icons.BasketballIcon,
  bed: Icons.BedIcon,
  'bell-hotel': Icons.BellHotelIcon,
  'bell-muted': Icons.BellMutedIcon,
  'bell-snoozed': Icons.BellSnoozedIcon,
  bell: Icons.BellIcon,
  billboard: Icons.BillboardIcon,
  board: Icons.BoardIcon,
  'bold-light': Icons.BoldLightIcon,
  'book-open': Icons.BookOpenIcon,
  bookmarks: Icons.BookmarksIcon,
  'box-cube': Icons.BoxCubeIcon,
  briefcase: Icons.BriefcaseIcon,
  'building-capitol': Icons.BuildingCapitolIcon,
  'building-city': Icons.BuildingCityIcon,
  'building-hotel': Icons.BuildingHotelIcon,
  'bullhorn-quiet': Icons.BullhornQuietIcon,
  bullhorn: Icons.BullhornIcon,
  'button-press': Icons.ButtonPressIcon,
  'cake-birthday': Icons.CakeBirthdayIcon,
  calculator: Icons.CalculatorIcon,
  calendar: Icons.CalendarIcon,
  camera: Icons.CameraIcon,
  car: Icons.CarIcon,
  card: Icons.CardIcon,
  'chat-bubbles-square': Icons.ChatBubblesSquareIcon,
  'chat-urgent': Icons.ChatUrgentIcon,
  chat: Icons.ChatIcon,
  'check-box': Icons.CheckBoxIcon,
  'check-box-empty': Icons.CheckBoxEmptyIcon,
  'check-filled': Icons.CheckFilledIcon,
  'check-shield': Icons.CheckShieldIcon,
  'check-task': Icons.CheckTaskIcon,
  'check-todo': Icons.CheckTodoIcon,
  check: Icons.CheckIcon,
  'church-cross': Icons.ChurchCrossIcon,
  'circle-aim': Icons.CircleAimIcon,
  circle: Icons.CircleIcon,
  'clipboard-list': Icons.ClipboardListIcon,
  'clipboard-plus': Icons.ClipboardPlusIcon,
  'clock-out': Icons.ClockOutIcon,
  'clock-in': Icons.ClockInIcon,
  clock: Icons.ClockIcon,
  'coast-symbol': Icons.CoastSymbolIcon,
  coffee: Icons.CoffeeIcon,
  'comparison-checkbox-grid-all-of': Icons.ComparisonCheckboxGridAllOfIcon,
  'comparison-checkbox-grid-none-of': Icons.ComparisonCheckboxGridNoneOfIcon,
  'comparison-checkbox-grid-one-of': Icons.ComparisonCheckboxGridOneOfIcon,
  'construction-crane': Icons.ConstructionCraneIcon,
  'construction-paintbrush': Icons.ConstructionPaintbrushIcon,
  'construction-sign': Icons.ConstructionSignIcon,
  contrast: Icons.ContrastIcon,
  'credit-card': Icons.CreditCardIcon,
  'cutlery-fork-knife': Icons.CutleryForkKnifeIcon,
  departments: Icons.DepartmentsIcon,
  'delivery-cart': Icons.DeliveryCartIcon,
  descending: Icons.DescendingIcon,
  'dots-wide': Icons.DotsWideIcon,
  dots: Icons.DotsIcon,
  'dots-grab-narrow': Icons.DotsGrabNarrowIcon,
  doughnut: Icons.DoughnutIcon,
  'divide-sign': Icons.DivideSignIcon,
  dumbbell: Icons.DumbbellIcon,
  'duplicate-squares': Icons.DuplicateSquaresIcon,
  squares: Icons.SquaresIcon,
  envelope: Icons.EnvelopeIcon,
  'equal-sign': Icons.EqualSignIcon,
  'event-create': Icons.EventCreateIcon,
  exit: Icons.ExitIcon,
  'exclamation-filled': Icons.ExclamationFilledIcon,
  'exclamation-outline': Icons.ExclamationOutlineIcon,
  'exit-heavy': Icons.ExitHeavyIcon,
  'eye-hide': Icons.EyeHideIcon,
  'eye-show': Icons.EyeShowIcon,
  'face-cat': Icons.FaceCatIcon,
  'face-robot': Icons.FaceRobotIcon,
  'face-sad': Icons.FaceSadIcon,
  'face-skull': Icons.FaceSkullIcon,
  'face-smile-filled': Icons.FaceSmileFilledIcon,
  'face-smile': Icons.FaceSmileIcon,
  'face-wink': Icons.FaceWinkIcon,
  'file-resume': Icons.FileResumeIcon,
  file: Icons.FileIcon,
  'filter-funnel': Icons.FilterFunnelIcon,
  'filter-knobs': Icons.FilterKnobsIcon,
  'fire-flame': Icons.FireFlameIcon,
  'flag-wave': Icons.FlagWaveIcon,
  flag: Icons.FlagIcon,
  'flower-daisy': Icons.FlowerDaisyIcon,
  'flower-lotus': Icons.FlowerLotusIcon,
  'flower-tulip': Icons.FlowerTulipIcon,
  gear: Icons.GearIcon,
  gif: Icons.GifIcon,
  'glasses-toast': Icons.GlassesToastIcon,
  global: Icons.GlobalIcon,
  grain: Icons.GrainIcon,
  'graph-analytics': Icons.GraphAnalyticsIcon,
  'greater-than-sign': Icons.GreaterThanSignIcon,
  'greater-than-equal-sign': Icons.GreaterThanEqualSignIcon,
  group: Icons.GroupIcon,
  hamburger: Icons.HamburgerIcon,
  'hand-heart': Icons.HandHeartIcon,
  hand: Icons.HandIcon,
  handshake: Icons.HandshakeIcon,
  hashtag: Icons.HashtagIcon,
  'hat-baseball': Icons.HatBaseballIcon,
  'hat-chef': Icons.HatChefIcon,
  'hat-crown': Icons.HatCrownIcon,
  'hat-graduation': Icons.HatGraduationIcon,
  headset: Icons.HeadsetIcon,
  'heart-broken': Icons.HeartBrokenIcon,
  heart: Icons.HeartIcon,
  heartbeat: Icons.HeartbeatIcon,
  'house-line': Icons.HouseLineIcon,
  'id-badge': Icons.IdBadgeIcon,
  'id-symbol': Icons.IdSymbolIcon,
  'image-filled': Icons.ImageFilledIcon,
  'image-portrait': Icons.ImagePortraitIcon,
  imagestack: Icons.ImagestackIcon,
  info: Icons.InfoIcon,
  'info-i': Icons.InfoIIcon,
  'info-outline': Icons.InfoOutlineIcon,
  invite: Icons.InviteIcon,
  italic: Icons.ItalicIcon,
  key: Icons.KeyIcon,
  layout: Icons.LayoutIcon,
  leaf: Icons.LeafIcon,
  'less-than-sign': Icons.LessThanSignIcon,
  'less-than-equal-sign': Icons.LessThanEqualSignIcon,
  'light-bulb': Icons.LightBulbIcon,
  'lightning-bolt': Icons.LightningBoltIcon,
  'link-add': Icons.LinkAddIcon,
  link: Icons.LinkIcon,
  list: Icons.ListIcon,
  lock: Icons.LockIcon,
  'lock-outline': Icons.LockOutlineIcon,
  'magic-wand': Icons.MagicWandIcon,
  'magnifying-glass': Icons.MagnifyingGlassIcon,
  'magnifying-search-01': Icons.MagnifyingSearch01Icon,
  math: Icons.MathIcon,
  medal: Icons.MedalIcon,
  meter: Icons.MeterIcon,
  microphone: Icons.MicrophoneIcon,
  'microphone-mute': Icons.MicrophoneMuteIcon,
  minus: Icons.MinusIcon,
  'mobile-add': Icons.MobileAddIcon,
  'mobile-chat': Icons.MobileChatIcon,
  'money-bag': Icons.MoneyBagIcon,
  'money-coins': Icons.MoneyCoinsIcon,
  'money-dollar-circle': Icons.MoneyDollarCircleIcon,
  'money-receipt': Icons.MoneyReceiptIcon,
  'money-refund': Icons.MoneyRefundIcon,
  moon: Icons.MoonIcon,
  'minus-negative': Icons.MinusNegativeIcon,
  'multi-line': Icons.MultiLineIcon,
  'multiply-sign': Icons.MultiplySignIcon,
  'music-notes': Icons.MusicNotesIcon,
  'new-group': Icons.NewGroupIcon,
  'no-entry': Icons.NoEntryIcon,
  no_entry: Icons.NoEntryLegacyIcon,
  'not-equal-sign': Icons.NotEqualSignIcon,
  notebook: Icons.NotebookIcon,
  outline: Icons.OutlineIcon,
  pacman: Icons.PacmanIcon,
  palette: Icons.PaletteIcon,
  paperclip: Icons.PaperclipIcon,
  'party-celebrate': Icons.PartyCelebrateIcon,
  'pen-filled': Icons.PenFilledIcon,
  pen: Icons.PenIcon,
  'pencil-paper': Icons.PencilPaperIcon,
  pencil: Icons.PencilIcon,
  people: Icons.PeopleIcon,
  percent: Icons.PercentIcon,
  'person-chef': Icons.PersonChefIcon,
  'person-concierge': Icons.PersonConciergeIcon,
  'person-man': Icons.PersonManIcon,
  'person-officer': Icons.PersonOfficerIcon,
  'person-heavy': Icons.PersonHeavyIcon,
  'person-woman': Icons.PersonWomanIcon,
  person: Icons.PersonIcon,
  phone: Icons.PhoneIcon,
  pie: Icons.PieIcon,
  'pin-location': Icons.PinLocationIcon,
  'pin-world': Icons.PinWorldIcon,
  plug: Icons.PlugIcon,
  'plus-circle': Icons.PlusCircleIcon,
  'plus-heavy': Icons.PlusHeavyIcon,
  plus: Icons.PlusIcon,
  'push-pin': Icons.PushPinIcon,
  potion: Icons.PotionIcon,
  present: Icons.PresentIcon,
  'qr-code': Icons.QrCodeIcon,
  'question-mark': Icons.QuestionMarkIcon,
  'radio-button': Icons.RadioButtonIcon,
  'receipt-long': Icons.ReceiptLongIcon,
  'remove-filled': Icons.RemoveFilledIcon,
  'remove-x': Icons.RemoveXIcon,
  'remove-x-outlined': Icons.RemoveXOutlinedIcon,
  repeat: Icons.RepeatIcon,
  'road-sign': Icons.RoadSignIcon,
  'scale-justice': Icons.ScaleJusticeIcon,
  screenshare: Icons.ScreenshareIcon,
  'search-look-up': Icons.SearchLookUpIcon,
  'send-filled': Icons.SendFilledIcon,
  'send-outline': Icons.SendOutlineIcon,
  'sign-board': Icons.SignBoardIcon,
  'signature-ballpoint-pen': Icons.SignatureBallpointPenIcon,
  'single-select-list': Icons.SingleSelectListIcon,
  'single-view': Icons.SingleViewIcon,
  'slide-left-arrow': Icons.SlideLeftArrowIcon,
  'slide-right-arrow': Icons.SlideRightArrowIcon,
  smile: Icons.SmileIcon,
  snowman: Icons.SnowmanIcon,
  sparkle: Icons.SparkleIcon,
  'split-view': Icons.SplitViewIcon,
  'squares-stacked': Icons.SquaresStackedIcon,
  'stack-cards': Icons.StackCardsIcon,
  'star-outline': Icons.StarOutlineIcon,
  'star-rate': Icons.StarRateIcon,
  star: Icons.StarIcon,
  'start-play-timer': Icons.StartPlayTimerIcon,
  stethoscope: Icons.StethoscopeIcon,
  'store-location': Icons.StoreLocationIcon,
  'store-shop': Icons.StoreShopIcon,
  storefront: Icons.StorefrontIcon,
  sun: Icons.SunIcon,
  sunset: Icons.SunsetIcon,
  swap: Icons.SwapIcon,
  syringe: Icons.SyringeIcon,
  tab: Icons.TabIcon,
  'table-grid': Icons.TableGridIcon,
  'tag-shopping': Icons.TagShoppingIcon,
  tag: Icons.TagIcon,
  target: Icons.TargetIcon,
  'task-filled': Icons.TaskFilledIcon,
  task: Icons.TaskIcon,
  'thumb-down': Icons.ThumbDownIcon,
  'thumb-up': Icons.ThumbUpIcon,
  ticket: Icons.TicketIcon,
  'time-alarm': Icons.TimeAlarmIcon,
  'time-clock': Icons.TimeClockIcon,
  'time-hourglass': Icons.TimeHourglassIcon,
  'time-repeat': Icons.TimeRepeatIcon,
  'time-stopwatch': Icons.TimeStopwatchIcon,
  'time-urgent': Icons.TimeUrgentIcon,
  'time-watch': Icons.TimeWatchIcon,
  'title-t': Icons.TitleTIcon,
  trash: Icons.TrashIcon,
  'tree-evergreen': Icons.TreeEvergreenIcon,
  trophy: Icons.TrophyIcon,
  'truck-delivery': Icons.TruckDeliveryIcon,
  'truck-front': Icons.TruckFrontIcon,
  umbrella: Icons.UmbrellaIcon,
  'underline-light': Icons.UnderlineLightIcon,
  'unfilled-circle': Icons.UnfilledCircleIcon,
  'upload-arrow': Icons.UploadArrowIcon,
  urgent: Icons.UrgentIcon,
  'video-recorder': Icons.VideoRecorderIcon,
  'water-drop': Icons.WaterDropIcon,
  'water-faucet': Icons.WaterFaucetIcon,
  waves: Icons.WavesIcon,
  'wrench-tools': Icons.WrenchToolsIcon,
  wrench: Icons.WrenchIcon,
  zzzs: Icons.ZzzsIcon,
};

export function getIconV2(icon: keyof typeof MBIconV2NameMap): MBImageURISource {
  return MBIconV2NameMap[icon];
}

export type MBIconV2Name = keyof typeof MBIconV2NameMap;
